// Avatar — circular user/plan avatar. Shows an image when `src` is given, else
// initials derived from `name`, on a gradient/tone background.
import PropTypes from 'prop-types';
import { cx } from '../../../utils/cx';
import './avatar.css';

const initials = (name = '') =>
  name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w[0])
    .join('')
    .toUpperCase();

export function Avatar({ name, src, size = 'md', gradient, className }) {
  return (
    <span
      className={cx('avatar', `avatar--${size}`, className)}
      style={gradient ? { background: gradient } : undefined}
      aria-label={name}
      role="img"
    >
      {src ? <img src={src} alt={name || ''} /> : initials(name)}
    </span>
  );
}

Avatar.propTypes = {
  name: PropTypes.string,
  src: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  /** CSS background (e.g. a plan logo gradient). */
  gradient: PropTypes.string,
  className: PropTypes.string,
};

export default Avatar;
